import React from 'react';
import { Link } from 'react-router-dom';
import { useTooltip } from '@app/providers';

const AuthButtons = () => {
  const { showTooltip, hideTooltip } = useTooltip();

  return (
    <div className="auth-buttons">
      <Link
        to="/login"
        className="retro-button auth-button"
        onMouseEnter={() => showTooltip('ВХОД', 'Войдите в свой аккаунт', 'Авторизация в My Ultimate Game Challenge')}
        onMouseLeave={hideTooltip}
      >
        <span className="nav-icon">
          <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
            <circle cx="12" cy="8" r="4" stroke="currentColor" fill="none" strokeWidth="2"/>
            <path d="M5 20V19C5 15 8 13 12 13C16 13 19 15 19 19V20" stroke="currentColor" fill="none" strokeWidth="2"/>
          </svg>
        </span>
        ВХОД
      </Link>

      <Link
        to="/register"
        className="retro-button auth-button"
        onMouseEnter={() => showTooltip('РЕГИСТРАЦИЯ', 'Создайте новый аккаунт', 'Присоединяйтесь к My Ultimate Game Challenge')}
        onMouseLeave={hideTooltip}
      >
        <span className="nav-icon">
          <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
            <path d="M12 5V19" stroke="currentColor" strokeWidth="2"/>
            <path d="M5 12H19" stroke="currentColor" strokeWidth="2"/>
          </svg>
        </span>
        РЕГИСТРАЦИЯ
      </Link>
    </div>
  );
};

export default AuthButtons;
